//路由守卫
import router from "./index";
import yhconfig from '@/yhconfig.js'
import * as dd from "dingtalk-jsapi";
import axios from 'axios'

router.beforeEach(async (to, from, next) => {
  // app中调试使用
  // if (to.path === '/index') {
  //   next()
  // } else {
  //   let param = '';
  //   if(to.query.code) {
  //     param += '?code=' + to.query.code
  //   }
  //   next('/index' + param)
  // }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.path === '/page/404' || to.path === '/page/403' || to.path === '/task/preview' || to.path === '/odaPreview' || to.path === '/login') {
    next()
  } else {
    // 用户认证
    let token = sessionStorage.getItem('usertoken')
    if (!token) {
      // 钉钉用户认证
      if (dd.env.platform !== 'notInDingTalk' && !yhconfig.test) {
        dd.ready(function () {
          // 钉钉环境获取code
          dd.runtime.permission.requestAuthCode({
            corpId: yhconfig.ddcorpid, // 企业id
            onSuccess: async function (result) {
              // 通过code换用户信息
              let res = await axios.get(yhconfig.ddurl + '?code=' + result.code);
              if (res.data) {
                // 通过用户信息换token
                let rel = await axios.post('/loginForDingDing?username=' + (yhconfig.test ? yhconfig.devname : res.data))
                if (rel.data.token) {
                  axios.defaults.headers.common['Authorization'] = rel.data.token
                  sessionStorage.setItem('usertoken', rel.data.token)
                  let reg = await axios.get('/getInfo')
                  sessionStorage.setItem('username', reg.data.user.nickName)
                  next()
                } else {
                  next('/page/403')
                }
              } else {
                next('/page/403')
              }
            }
          })
        })
        // 企业微信认证  移动五矿认证
      } else if (to.query.code && !yhconfig.test) {
        // 通过code换用户信息
        let res = await axios.get(yhconfig.qywxurl + '?code=' + to.query.code);
        if (res.data) {
          // 通过用户信息换token
          let rel = await axios.post('/loginForDingDing?username=' + (yhconfig.test ? yhconfig.devname : res.data))
          if (rel.data && rel.data.token) {
            axios.defaults.headers.common['Authorization'] = rel.data.token
            sessionStorage.setItem('usertoken', rel.data.token)
            let reg = await axios.get('/getInfo')
            sessionStorage.setItem('username', reg.data.user.nickName)
            next()
          } else {
            next('/page/403')
          }
        } else {
          next('/page/403')
        }
        //非矿OA用户认证
      } else if (to.query.token && !yhconfig.test) {
        // 通过token换用户信息
        let data = { "token": to.query.token, "refresh_new_token": "true" }
        let res = await axios.get('/eoffice/server/public/api/auth/login-info/refresh', {
          headers: { Authorization: "Bearer " + to.query.token },
          params: data
        });
        if (res.status === 1 && res.data.current_user.user_job_number) {
          // 通过用户信息换token
          let rel = await axios.post('/loginForDingDing?dingId=id&username=' + (yhconfig.test ? yhconfig.devname : res.data.current_user.user_job_number))
          if (rel.data && rel.data.token) {
            axios.defaults.headers.common['Authorization'] = rel.data.token
            sessionStorage.setItem('usertoken', rel.data.token)
            let reg = await axios.get('/getInfo')
            sessionStorage.setItem('username', reg.data.user.userName)
            next()
          } else {
            next('/page/403')
          }
        } else {
          next('/page/403')
        }
      } else {
        if(yhconfig.test) {
          // 通过用户信息换token
          let res = await axios.post('/loginForDingDing?username=' + yhconfig.devname)
          if (res.data && res.data.token) {
            axios.defaults.headers.common['Authorization'] = res.data.token
            sessionStorage.setItem('usertoken', res.data.token)
            sessionStorage.setItem('username', yhconfig.devname)
            next()
          } else {
            next('/403')
          }
        } else {
          next('/login')
        }
      }
    } else {
      axios.defaults.headers.common['Authorization'] = token
      next()
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/login.js